/** Rendered size of the thumbs-up / thumbs-down glyphs, in px. */
export const THUMBS_ICON_SIZE_PX = 16;

// The design-system message-square-dots glyph natively renders at
// 17x17 (the Figma "Icon/messageSquareDots / Size=Small" frame). The
// thumbs glyphs remain at 16x16 — both fit inside the shared 32x32
// hit area without affecting layout.
export const OVERFLOW_ICON_SIZE_PX = 17;
